<template>
  <v-bottom-sheet v-model="$store.state.bookingSelectInfoDialogStatus" hide-overlay elevation="0">
    <v-card color="white" rounded="t-xl" :loading="loading">
      <v-card-text class="px-1 pt-0">
        <v-row justify="center">
          <v-col cols="12" md="9" lg="6">
            <v-card variant="text">
              <v-card-actions>
                <h3>{{ $store.state.info.info_form.form_name }}</h3>
                <v-spacer></v-spacer>
                <v-btn icon @click="showForm=!showForm" v-if="showForm">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-btn v-else icon @click="$store.commit('setBookingSelectInfoDialogStatus', false)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
              <v-divider></v-divider>
              <v-card-text class="px-1" v-if="!showForm">
                <p class="text-center mb-3">{{ $store.state.info.info_form.form_description }}</p>
                <v-row v-if="!!$store.state.info.info_related_field && $store.state.info.info_related_field.length > 0">
                  <v-col cols="12" md="6" v-for="(i, index) in $store.state.entries" :key="index">
                    <v-card class="pa-2" color="white" elevation="3" rounded="lg">
                      <div class="d-flex flex-column text-center">
                        <div class="d-flex align-center justify-space-between text-center">
                          {{ i[$store.state.info.info_title_field] }}
                           <v-btn @click="item=Object.assign({},i);showForm=true;" size="small" icon="mdi-pencil" variant="flat"/>
                        </div>
                        <div class="text-center">
                          {{ i[$store.state.info.info_description_field] }}
                        </div>
                        <v-btn  elevation="5" color="primary" rounded="lg" class="mt-4"
                          @click="$store.commit('setBookingSelectedInfo', i);$store.commit('setBookingSelectInfoDialogStatus', false);$store.commit('setBookingSelectEmployeDialogStatus', true);"
                          >
                          {{ $t('select_and_continue') }}
                        </v-btn>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card class="pa-2" color="white" elevation="3" rounded="lg">
                      <div class="d-flex flex-column text-center">
                        <v-btn  elevation="5" color="primary" rounded="lg" class="my-2"
                          @click="showForm=true;item={};">
                          <v-icon class="ml-2">mdi-plus</v-icon>
                          افزودن
                        </v-btn>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
              <FormC v-else :loading="loading" v-model="item" :form_elements="elements"
                @submit="updateUserData"
                :form="$store.state.info.info_form" />
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
  import FormC from '@/components/form/form.vue';
  export default {
    components: {
      FormC,
    },
    name: "SubmitBookingPage",
    data: () => ({
      showForm: false,
      loading: false,
      item: {},
    }),
    methods: {
      async updateUserData(data) {
        let entry = this.$store.state.info.info_form.elements
          .map(e => `element_${e.element_id}`) // فقط کلیدها
          .filter(key => key in data) // فقط کلیدهایی که توی data هستن
          .reduce((obj, key) => {
            obj[key] = data[key];
            return obj;
          }, {});
        entry[this.$store.state.info.info_related_field] = this.$store.state.user.entry.id; // این آی دی کاربر رو میده به این فیلد
        if(data["id"]) entry["id"] = data["id"];
        this.loading = true;
        try {
          const response = await this.$api.post('/GuestForm/form/booking_update', {
            form_id: this.$store.state.info.info_form.form_id,
            data: entry,
          }, {
            encrypt: true
          });
          if (response.data.success) {
            this.showForm = false;
            this.GetEntries();
          }
        } catch (error) {
          console.error(error);
        }
        this.loading = false;
      },
      async GetEntries() {
        this.loading = true;
        try {
          const response = await this.$api.post('/GuestForm/entries', {
            form_id: this.$store.state.info.info_form.form_id,
            info_related_field: this.$store.state.info.info_related_field,
          }, {
            encrypt: true
          });
          if (response.data.success) {
            this.$store.state.entries = response.data.data;
          }
        } catch (error) {
          console.error(error);
        }
        this.loading = false;
      },
    },
    computed: {
      elements() {
        return this.$store.state.info.info_form.elements.filter(e => e.element_is_private != '1' && e.element_type !=
          'form' && e.element_type != 'line');
      }
    },
    mounted() {
      if(this.$store.state.entries.length == 0){
        this.GetEntries();
      }
    }
  }
</script>

<style>
  .v-slide-group__next,
  .v-slide-group__prev {
    min-width: 30px !important;
  }
</style>